import { BaseModel } from '@Core';
import { ZoneSM, Zones } from './Zones';
import { ServiceSM } from './ServiceSM';

export interface LocationSM extends BaseModel {
    Name: string;

    Address1: string;

    Address2: string;

    Address3: string;

    Town: string;

    County: string;

    Postcode: string;

    ExternalReference: string;

    Jurisdiction: number;

    InitialLegislation: number;

    Longitude: string;

    Latitude: string;

    Notes: string;

    LocationStatus?: LocationSMStatus;
    Zones?: ZoneSM[];

    CameraCount?: number;
    Services?: ServiceSM;

    Priority: LocationPriority;
}

export interface ECLocationDetail {
    Name: string;
    Zones: string[];
}

export interface ECCameraDetail {
    CameraName: string;
    Locations: ECLocationDetail[];
}

export interface ECStats {
    CameraCount: number;
    LocationCount: number;
    ZoneCount: number;
    Cameras: ECCameraDetail[];
}

export interface Location extends LocationSM {
    Zones?: Zones[];

    PTZCameraCount?: number;
    SP111CameraCount?: number;
    Solar4gCameraCount?: number;
    ECStats?: ECStats;
}

export enum LocationPriority {
    P0,
    P1,
    P2,
    P3,
    P4,
    P5,
}

export enum LocationSMStatus {
    Prospective,
    Live,
    Transferred,
    Decommissioned,
    OnHold,
}
